module.exports = __webpack_public_path__ + "static/media/select.c701e785.svg";